import PropTypes from 'prop-types';
import React, { useEffect, useState, memo } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import image1 from '../../assets/images/seagull/seagull-1.json';
import image2 from '../../assets/images/seagull/seagull-2.json';
import image3 from '../../assets/images/seagull/seagull-3.json';
import './Seagull.scss';

const images = [
	image1,
	image2,
	image3,
];

export const Seagull = memo(props => {
	const { className, position, translateTo, animate, type } = props;
	const extendedClassName = 'seagull-wrapper' + (className ? ' ' + className : '');
	const src = images[type];
	const [hasBeenAnimated, setHasBeenAnimated] = useState(false);
	const isVisible = animate || hasBeenAnimated;
	const styleSeagull = {
		left: `${position[0]}vw`,
		top: `${position[1]}vh`,
		transform: `translate(${translateTo[0]}%, ${translateTo[1]}%)`
	};
	
	useEffect(() => {
		if (animate && !hasBeenAnimated) {
			setHasBeenAnimated(true);
		}
	}, [animate, hasBeenAnimated]);

	return isVisible && (
		<div className={extendedClassName} style={styleSeagull}>
			<Player
				autoplay
				loop
				src={src}
				className="seagull"
			/>
		</div>
	);
});

Seagull.propsTypes = {
	animate: PropTypes.bool,
	className: PropTypes.string,
	position: PropTypes.arrayOf(PropTypes.number),
	translateTo: PropTypes.arrayOf(PropTypes.number),
	type: PropTypes.number,
};
